import { Divider } from "../Divider.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/divider/variants/VerticalDivider.tsx
const VerticalDivider = ({ variant = "full", ...restProps }) => {
	return /* @__PURE__ */ jsx(Divider, {
		...restProps,
		variant,
		orientation: "vertical"
	});
};

//#endregion
export { VerticalDivider };